module.exports = __webpack_public_path__ + "img/Presenter.68ab5aaf.png";